module.exports = __webpack_public_path__ + "13c696e051165e64d6166b0b881d56ac.pdf";